import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import { Link, useParams } from 'react-router-dom';
import { Topheader } from '../../components/Topheader';
import { DataGetApi } from '../../helpers/PostDataApi';
import config from '../../constants/config';
import { renderAnnouncementMessage } from '../../components/Announcement/Announcement';
import './AnnouncementGroups.css';

const getToken = () => JSON.parse(localStorage.getItem('user') || '{}')?.token;

const AnnouncementGroupDetails = () => {
  const { groupId } = useParams();
  const [group, setGroup] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;
    DataGetApi(`${config.BASEURL}announcement/groups`, {}, getToken()).then((response) => {
      if (!isMounted) return;
      const loadedGroup = response?.data?.groups?.find((item) => String(item._id) === String(groupId));
      if (response?.status === 200 && loadedGroup) {
        setGroup(loadedGroup);
      } else {
        setError('Unable to load this announcement group.');
      }
      setIsLoading(false);
    });
    return () => {
      isMounted = false;
    };
  }, [groupId]);

  return (
    <div className="rightPanel">
      <Topheader />
      <main className="contentPart announcementGroupsPage">
        <Button component={Link} startIcon={<ArrowBackIcon />} to="/Announcement">
          All groups
        </Button>
        {isLoading && <CircularProgress aria-label="Loading announcement group" />}
        {error && (
          <Typography color="error" role="alert">
            {error}
          </Typography>
        )}
        {group && (
          <>
            <div className="announcementDetailHeading">
              <div>
                <Typography component="h1" variant="h5">
                  {group.name}
                </Typography>
                <Typography color="textSecondary" variant="body2">
                  {group.locations?.length || 0} locations in this group
                </Typography>
              </div>
              <Button
                color="primary"
                component={Link}
                startIcon={<EditIcon />}
                to={`/Announcement/groups/${groupId}/edit`}
                variant="contained"
              >
                Edit announcement
              </Button>
            </div>
            <div className="announcementDetailLayout">
              <Paper className="announcementLocationsPanel">
                <Typography component="h2" variant="h6">
                  Locations
                </Typography>
                <TableContainer className="announcementLocationsTable">
                  <Table aria-label={`${group.name} locations`} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Location</TableCell>
                        <TableCell>MID</TableCell>
                        <TableCell align="right">History</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(group.locations || []).map((location) => (
                        <TableRow hover key={location._id}>
                          <TableCell>
                            <Link
                              className="announcementLocationLink"
                              to={{
                                pathname: `/Announcement/locations/${location._id}/history`,
                                state: { groupId, mId: location.mId },
                              }}
                            >
                              {location.locationName || location._id}
                            </Link>
                          </TableCell>
                          <TableCell>{location.mId || 'Not set'}</TableCell>
                          <TableCell align="right">
                            <Button
                              component={Link}
                              size="small"
                              to={{
                                pathname: `/Announcement/locations/${location._id}/history`,
                                state: { groupId, mId: location.mId },
                              }}
                            >
                              View history
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <Paper className="announcementPreviewPanel">
                <Typography component="h2" variant="h6">
                  Applied announcement
                </Typography>
                {group.announcement ? (
                  <div className="announcementGroupPreview">
                    <div className="announcementGroupPreviewTitle">{group.announcement.announcement.title}</div>
                    <div className="announcementGroupPreviewMessage">
                      {renderAnnouncementMessage(group.announcement.announcement.message)}
                    </div>
                  </div>
                ) : (
                  <Typography color="textSecondary">No announcement is currently applied to this group.</Typography>
                )}
              </Paper>
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default AnnouncementGroupDetails;
